"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("./cache");
var setLibraryName = function (library) {
    if (!library) {
        console.error('[@ice/stark-app] setLibraryName: params can not be empty!');
        return;
    }
    ;
    cache_1.setCache('library', library);
};
exports.default = setLibraryName;
